import { 
  bagOutline, 
  carOutline, 
  settingsOutline, 
  starOutline, 
  sparklesOutline, 
  informationCircleOutline 
} from 'ionicons/icons';

/**
 * Получить иконку уведомления по типу
 */
export const getNotificationIcon = (type: string | null) => {
    switch(type) {
        case 'order': return bagOutline;
        case 'delivery': return carOutline;
        case 'system': return settingsOutline;
        case 'recommendation': return starOutline;
        case 'new': return sparklesOutline;
        case 'stock': return sparklesOutline;
        default: return informationCircleOutline;
    }
};

/**
 * Получить цвет бейджа уведомления по типу
 */
export const getBadgeColor = (type: string | null) => {
    switch(type) {
        case 'order': return 'bg-blue-500 text-white';
        case 'delivery': return 'bg-orange-500 text-white';
        case 'system': return 'bg-gray-500 text-white';
        case 'recommendation': return 'bg-pink-500 text-white';
        case 'new': return 'bg-pink-500 text-white';
        case 'stock': return 'bg-orange-500 text-white';
        default: return 'bg-gray-500 text-white';
    }
};

/**
 * Получить текст кнопки действия по типу уведомления
 */
export const getActionButtonText = (type: string | null) => {
    switch(type) {
        case 'order': return 'Посмотреть заказ';
        case 'delivery': return 'Отследить';
        case 'system': return 'Ознакомиться';
        case 'recommendation': return 'Посмотреть';
        case 'new': return 'Заказать';
        case 'stock': return 'Заказать';
        default: return 'Посмотреть';
    }
};

/**
 * Получить текст бейджа уведомления по типу
 */
export const getBadgeText = (type: string | null) => {
    switch(type) {
        case 'order': return 'Заказ';
        case 'delivery': return 'Доставка';
        case 'system': return 'Система';
        case 'recommendation': return 'Рекомендации';
        case 'new': return 'Новинка';
        case 'stock': return 'Акции';
        default: return 'Уведомление';
    }
};

/**
 * Форматировать дату и время в строку
 */
export const formatDateTime = (dateString: string | null) => {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    
    return `${day}.${month}.${year} в ${hours}:${minutes}`;
};
